<div role="region" class="home-b-training-section">
  <header class="home-b-training-section__header" role="banner">
    <mat-icon class="home-b-training-section__header__icon" [svgIcon]="icon" role="presentation"></mat-icon>
    <h2 role="heading">{{ title }}</h2>
  </header>

  <ul class="home-b-training-section__cards-list">
    <li *ngFor="let card of cardsList; trackBy: trackByCard">
      <app-card [cardContent]="card" [accentColor]="accentColor"></app-card>
    </li>
  </ul>
</div>
